import React from 'react';
import GatsbyLink from 'gatsby-link';

const linkStyles = 'no-underline font-bold';

export const mergeStyles = className =>
  `${className ? `${className} ${linkStyles}` : linkStyles}`;

export const ExternalLink = ({ children, className = undefined, ...props }) => (
  <a className={mergeStyles(className)} {...props} rel="noopener noreferrer">
    {children}
  </a>
);

export const Link = ({ children, className = undefined, ...props }) => (
  <GatsbyLink className={mergeStyles(className)} {...props}>
    {children}
  </GatsbyLink>
);



// WEBPACK FOOTER //
// ./src/components/Links.js